var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgTestIcon(props) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.355,
    height: 138.922
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.122
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopOpacity: 0.09
  })), _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 14.124,
    y1: -1.935,
    x2: 14.124,
    y2: -2.759,
    gradientUnits: "objectBoundingBox"
  }, _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  })), _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "gray",
    stopOpacity: 0.122
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d5d5d5",
    d: "M24.179 79.218L.027 51.782 72.29 0l72.263 51.782-24.539 27.436z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#514abf",
    d: "M24.179 79.218L.027 51.782 72.29 0l72.263 51.782-24.539 27.436z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d5d5d5",
    d: "M0 54.961h141v62H0z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 54.961)",
    fill: `url(#${_id})`,
    d: "M0 0h141v62H0z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d5d5d5",
    d: "M144.552 138.922H.027v-87.14L72.29 95.449l72.262-43.667z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ad29f",
    d: "M126.116 22.571l-15.327-11.753-40.6 52.951-22.553-17.291-11.753 15.328 30.212 23.132 7.748 5.806z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.754 109.943l-.575.281.066-.117-.05.016.071-.052L8 96.307l3.953 3.371 3.392 3.14-.974.476 1.095 1.931z",
    transform: "translate(-.117 -77.699)",
    fill: `url(#${_id2})`
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d5d5d5",
    d: "M11.444 22.339l3.1 2.874L.493 32.199l7.477-9.583z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.444 22.339l3.1 2.874L.493 32.199l7.477-9.583z",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#d5d5d5",
    d: "M7.828 19.256L.493 32.196l10.951-9.86z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d5d5d5",
    d: "M14.634 27.439L.508 32.105l11.811-8.815zM132.758 7.483l-3.095 5.365 22.691 3.695-14.615-10.177z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.758 7.483l-3.095 5.365 22.691 3.695-14.615-10.177z",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#d5d5d5",
    d: "M136.485 1.602l15.87 14.941-19.6-9.06z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#d5d5d5",
    d: "M130.5 16.002l21.792.416-20.344-7.226z"
  })));
}
export default SvgTestIcon;